// extracted by mini-css-extract-plugin
module.exports = {"content":"TableWithResults_content__3oZDR","info":"TableWithResults_info__rmBlU","subtitle":"TableWithResults_subtitle__1alyv"};